import React from "react";
import { useLang } from "../i18n";

const RIBEIRA = "/images/ribeira.jpg";

export default function PortoDifferentEyes() {
  const { t } = useLang();
  const p = t.philosophy;
  return (
    <section id="philosophy" data-testid="philosophy-section" className="relative isolate overflow-hidden">
      <img
        src={RIBEIRA}
        alt="The Ribeira waterfront of Porto glowing at golden hour"
        loading="lazy"
        className="editorial-band absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-[#1b2026]/55" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#1b2026]/75 via-transparent to-[#1b2026]/45" />

      <div className="relative max-w-4xl mx-auto px-6 md:px-10 py-32 md:py-48 text-center">
        <p data-testid="philosophy-eyebrow" className="text-[11px] md:text-sm uppercase tracking-[0.34em] text-[#F7F1E8]/80 mb-6">{p.eyebrow}</p>
        <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[#FDFAF3]">{p.title}</h2>
        <p className="mt-8 text-base md:text-xl text-[#F7F1E8]/90 leading-relaxed max-w-2xl mx-auto">{p.body}</p>
      </div>
    </section>
  );
}
